import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PolizasEmitirService } from 'src/app/core/providers/services/polizas-emitir/polizas-emitir.service';
import { take } from 'rxjs/operators';
import { DocumentacionCorreoService } from '../../core/providers/services/documentacion-correo/documentacion-correo.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent {
  formParamStatus = '';
  stepActive = '1';
  auxLink: string = location.pathname;
  showThanks = false;
  idPresu: number;
  currentRoute: string;
  polizaData: any;
  email: string;
  success: boolean;
  showLoader = true;
  isTPV = true;
  isPay = false;
  urlLogoCorredor = '';
  tokenURL = '';
  showHeader = false;


  //#region Constructor
  /**
   * @description constructor
   * @params activatedRoute
   * @params router
   * @params emailSrv
   * @params polSrv
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private emailSrv: DocumentacionCorreoService,
    private polSrv: PolizasEmitirService
  ) {
    this.router = router;
    this.emailSrv = emailSrv;
    this.polSrv = polSrv;
    this.activatedRoute = activatedRoute;
    this.activatedRoute.queryParams.subscribe((params: any) => {
      const bugetS: any = localStorage.getItem('budget');
      const isPay: any = localStorage.getItem('pay');
      const isReset: any = localStorage.getItem('resetForm');

      if (bugetS !== null) {
        this.isPay = true;
        if (params.success === 'true') {
          // Sin emisión de poliza
          this.success = true;
          this.showLoader = false;
          localStorage.setItem('stepThanks', 'true');
          localStorage.removeItem('next-step3');
          localStorage.removeItem('pay');
          this.isPay = false;
          this.setStepThanks();
        }
        if (params.success === 'false') {
          this.success = false;
          this.showLoader = false;
          localStorage.setItem('stepThanks', 'true');
          localStorage.removeItem('next-step3');
          localStorage.removeItem('pay');
          this.isPay = false;
          this.setStepThanks();
        } else {
          if (isReset === 'true') {
          this.showLoader = false;
          this.isPay = false;
          this.showThanks = false;
          }
        }
      } else {
        this.showLoader = false;
        this.isPay = false;
        if (isPay !== null) { this.isPay = true; }

        if (params.success === 'true') {
          // Sin emisión de poliza
          this.success = true;
          this.showLoader = false;
          localStorage.setItem('stepThanks', 'true');
          localStorage.removeItem('next-step3');
          localStorage.removeItem('pay');
          this.isPay = false;
          this.setStepThanks();
        }
        if (params.success === 'false') {
          this.success = false;
          this.showLoader = false;
          localStorage.setItem('stepThanks', 'true');
          localStorage.removeItem('next-step3');
          localStorage.removeItem('pay');
          this.isPay = false;
          this.setStepThanks();
        }
      }
      if (params.token !== undefined) {
        this.showHeader = false;
        this.tokenURL = params.token;
      } else {
        this.showHeader = true;
        this.tokenURL = '';
      }

    });
  }
  /**
   * @description emitir poliza
   */
  emitPolicy(): void {
    const number10 = 10;
    this.idPresu = parseInt(localStorage.getItem('budget'), number10);
    const numDoc: string = localStorage.getItem('ndc');
    this.email = localStorage.getItem('email');
    const data: any = {
      idPresupuesto: this.idPresu,
      documento: numDoc,
      email: this.email,
      confirmationNumber: '000000',
      salesCode: '0000'
    };
    this.polSrv.postPolicySend(data)
      .pipe(take(1))
      .subscribe((sendPol: any) => {
        let auxSend = false;
        if (sendPol.idError !== undefined && sendPol.idError === 0) { auxSend = true; }
        if (auxSend) {
          this.polizaData = sendPol;
          this.sendEmail();
        } else {
          this.showLoader = false;
          localStorage.setItem('stepThanks', 'true');
          this.setStepThanks();
          this.success = false;
          localStorage.removeItem('budget');
          localStorage.removeItem('email');
        }
      });

    localStorage.removeItem('budget');
    localStorage.removeItem('ndc');
  }
/**
 * @description enviar mail
 */
  sendEmail(): void {
    this.email = localStorage.getItem('email');

    const a: any = {
      idPoliza: this.polizaData.Id_poliza,
      indEmail: true,
      email: this.email
    };
    this.emailSrv.postDocumentationEmail(a)
      .pipe(take(1))
      .subscribe((emailD: any) => {
        this.showLoader = false;
        localStorage.removeItem('stepThanks');
        localStorage.removeItem('email');
        this.success = true;
        localStorage.setItem('stepThanks', 'true');
        this.setStepThanks();
        localStorage.removeItem('budget');
        localStorage.removeItem('email');
        localStorage.removeItem('stepThanks');
      });
  }
/**
 * @description paso agradecimiento
 */
  setStepThanks(): void {
    this.stepActive = localStorage.getItem('stepThanks');

    if (this.stepActive !== '' && this.stepActive !== null) {
      this.showThanks = true;
    }
  }
  /**
   * @description cerrar componente
   */
  closeComponent(): void {
    localStorage.removeItem('stepThanks');
    this.showThanks = false;
    const auxLink: string = this.router.url;
    const auxLink2: string[] = auxLink.split('?');
    // this.router.navigate([auxLink2[0]]);
    if (this.tokenURL === '') {
      this.router.navigate([auxLink2[0]]);
    } else {
      this.router.navigate([auxLink2[0]], { queryParams: { token: this.tokenURL }});
    }

  }
  /**
   * @description emitir datos
   * @params ev
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.close !== undefined && keyPress.close) {
        this.showThanks = false;
      }

    }
  }
/**
 * @description mostrar agradecimiento l
 * @params ev
 */
  showThanksL(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.thanks !== undefined && keyPress.thanks) {
        this.showThanks = true;
        this.success = true;
        this.isTPV = false;
      }

    }
  }
  /**
   * @description mostrar agradecimiento l
   * @params ev
   */
  brokerLogoUrl(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.showBrokerLogo !== undefined && keyPress.showBrokerLogo) {
        this.urlLogoCorredor = keyPress.urlBrokerLogo;
        this.showHeader = true;
      }
    } else {
      this.urlLogoCorredor = '';
    }
  }

}
